/**
 * Taxa de amostragem dinâmica por pressão.
 */

import { getUnifiedPressureLevel } from '../runtime/pressureModel';
import { getRuntimeMode } from '../runtime/runtimeMode';

export function getDynamicSampleRate(
  baseRate: number,
  pressureLevel: number
): number {
  if (pressureLevel <= 0.5) return baseRate;
  if (pressureLevel <= 0.75) return baseRate * 0.5;
  return baseRate * 0.25;
}

const CRITICAL_EVENT_TYPES = new Set([
  'PURCHASE',
  'LEAD',
  'INITIATE_CHECKOUT',
  'ADD_PAYMENT_INFO',
]);

export function shouldSampleEvent(
  baseRate = 1,
  random = Math.random(),
  eventType?: string
): boolean {
  if (eventType && CRITICAL_EVENT_TYPES.has(eventType)) return random < baseRate;
  const mode = getRuntimeMode();
  const pressure =
    mode === 'degraded' ? 0.9 : mode === 'pressure' ? 0.7 : getUnifiedPressureLevel();
  const rate = getDynamicSampleRate(baseRate, pressure);
  return random < rate;
}
